<button
  rv-button
  variant="secondary"
  class="tw-w-full tw-whitespace-nowrap"
  (click)="openNewFolderModal()"
>
  <mat-icon svgIcon="add-folder-2" aria-hidden="true" />
  New Folder
</button>
